export default __webpack_public_path__ + "static/media/oscer-pres-joint-swelling.1f998633.svg";